/* eslint-disable */
export const examsData = [
  'KRT_01_01_L_01',
  'KRT_01_01_L_02',
  'KRT_01_01_N_01',
  'KRT_01_01_N_02',
  'KRT_01_02_L_03',
  'KRT_01_02_L_04',
  'KRT_01_02_N_03',
  'KRT_01_02_N_04',
  'KRT_01_03_L_05',
  'KRT_01_03_L_06',
  'KRT_01_03_N_05',
  'KRT_01_03_N_06',
  'KRT_01_04_L_07',
  'KRT_01_04_L_08',
  'KRT_01_04_N_07',
  'KRT_01_04_N_08',
  'KRT_01_05_L_09',
  'KRT_01_05_L_10',
  'KRT_01_05_N_09',
  'KRT_01_05_N_10',
  'KRT_01_06_L_11',
  'KRT_01_06_L_12',
  'KRT_01_06_N_11',
  'KRT_01_06_N_12',
  'KRT_01_07_L_13',
  'KRT_01_07_L_14',
  'KRT_01_07_N_13',
  'KRT_01_07_N_14',
  'KRT_01_08_L_15',
  'KRT_01_08_L_16',
  'KRT_01_08_N_15',
  'KRT_01_08_N_16',
  'KRT_01_09_L_17',
  'KRT_01_09_L_18',
  'KRT_01_09_N_17',
  'KRT_01_09_N_18',
  'KRT_01_10_L_19',
  'KRT_01_10_L_20',
  'KRT_01_10_N_19',
  'KRT_01_10_N_20',
  'KRT_01_11_L_21',
  'KRT_01_11_L_22',
  'KRT_01_11_N_21',
  'KRT_01_11_N_22',
  'KRT_01_12_L_23',
  'KRT_01_12_L_24',
  'KRT_01_12_N_23',
  'KRT_01_12_N_24',
  'KRT_01_13_L_25',
  'KRT_01_13_L_26',
  'KRT_01_13_N_25',
  'KRT_01_13_N_26',
  'KRT_01_14_L_27',
  'KRT_01_14_L_28',
  'KRT_01_14_N_27',
  'KRT_01_14_N_28',
  'KRT_01_15_L_29',
  'KRT_01_15_L_30',
  'KRT_01_15_N_29',
  'KRT_01_15_N_30',
  'KRT_01_16_L_31',
  'KRT_01_16_L_32',
  'KRT_01_16_N_31',
  'KRT_01_16_N_32',
  'KRT_01_17_L_33',
  'KRT_01_17_L_34',
  'KRT_01_17_N_33',
  'KRT_01_17_N_34',
  'KRT_01_18_L_35',
  'KRT_01_18_L_36',
  'KRT_01_18_N_35',
  'KRT_01_18_N_36',
  'KRT_01_19_L_37',
  'KRT_01_19_L_38',
  'KRT_01_19_N_37',
  'KRT_01_19_N_38',
  'KRT_01_20_L_39',
  'KRT_01_20_L_40',
  'KRT_01_20_N_39',
  'KRT_01_20_N_40',
  'KRT_01_21_L_41',
  'KRT_01_21_L_42',
  'KRT_01_21_N_41',
  'KRT_01_21_N_42',
  'KRT_01_22_L_43',
  'KRT_01_22_L_44',
  'KRT_01_22_N_43',
  'KRT_01_22_N_44',
  'KRT_01_23_L_45',
  'KRT_01_23_L_46',
  'KRT_01_23_N_45',
  'KRT_01_23_N_46',
  'KRT_01_24_L_47',
  'KRT_01_24_L_48',
  'KRT_01_24_N_47',
  'KRT_01_24_N_48',
  'KRT_01_25_L_49',
  'KRT_01_25_L_50',
  'KRT_01_25_N_49',
  'KRT_01_25_N_50',
  'KRT_01_26_L_51',
  'KRT_01_26_L_52',
  'KRT_01_26_N_51',
  'KRT_01_26_N_52',
  'KRT_01_27_L_53',
  'KRT_01_27_L_54',
  'KRT_01_27_N_53',
  'KRT_01_27_N_54',
  'KRT_01_28_L_55',
  'KRT_01_28_L_56',
  'KRT_01_28_N_55',
  'KRT_01_28_N_56',
  'KRT_01_29_L_57',
  'KRT_01_29_L_58',
  'KRT_01_29_N_57',
  'KRT_01_29_N_58',
  'KRT_01_30_L_59',
  'KRT_01_30_L_60',
  'KRT_01_30_N_59',
  'KRT_01_30_N_60',
  'KRT_01_31_L_61',
  'KRT_01_31_L_62',
  'KRT_01_31_N_61',
  'KRT_01_31_N_62',
  'KRT_01_32_L_63',
  'KRT_01_32_L_64',
  'KRT_01_32_N_63',
  'KRT_01_32_N_64',
  'KRT_01_33_L_65',
  'KRT_01_33_L_66',
  'KRT_01_33_N_65',
  'KRT_01_33_N_66',
  'KRT_01_34_L_67',
  'KRT_01_34_L_68',
  'KRT_01_34_N_67',
  'KRT_01_34_N_68',
  'KRT_01_35_L_69',
  'KRT_01_35_L_70',
  'KRT_01_35_N_69',
  'KRT_01_35_N_70',
  'KRT_01_36_L_71',
  'KRT_01_36_L_72',
  'KRT_01_36_N_71',
  'KRT_01_36_N_72',
  'KRT_01_37_L_73',
  'KRT_01_37_L_74',
  'KRT_01_37_N_73',
  'KRT_01_37_N_74',
  'KRT_01_38_L_75',
  'KRT_01_38_L_76',
  'KRT_01_38_N_75',
  'KRT_01_38_N_76',
  'KRT_01_39_L_77',
  'KRT_01_39_L_78',
  'KRT_01_39_N_77',
  'KRT_01_39_N_78',
  'KRT_01_40_L_79',
  'KRT_01_40_L_80',
  'KRT_01_40_N_79',
  'KRT_01_40_N_80',
  'KRT_01_41_L_81',
  'KRT_01_41_L_82',
  'KRT_01_41_N_81',
  'KRT_01_41_N_82',
  'KRT_01_42_L_83',
  'KRT_01_42_L_84',
  'KRT_01_42_N_83',
  'KRT_01_42_N_84',
  'KRT_01_43_L_85',
  'KRT_01_43_L_86',
  'KRT_01_43_N_85',
  'KRT_01_43_N_86',
  'KRT_01_44_L_87',
  'KRT_01_44_L_88',
  'KRT_01_44_N_87',
  'KRT_01_44_N_88',
  'KRT_01_45_L_89',
  'KRT_01_45_L_90',
  'KRT_01_45_N_89',
  'KRT_01_45_N_90',
  'KRT_01_46_L_91',
  'KRT_01_46_L_92',
  'KRT_01_46_N_91',
  'KRT_01_46_N_92',
  'KRT_01_47_L_93',
  'KRT_01_47_L_94',
  'KRT_01_47_N_93',
  'KRT_01_47_N_94',
  'KRT_01_48_L_95',
  'KRT_01_48_L_96',
  'KRT_01_48_N_95',
  'KRT_01_48_N_96',
  'KRT_01_49_L_97',
  'KRT_01_49_L_98',
  'KRT_01_49_N_97',
  'KRT_01_49_N_98',
  'KRT_01_50_L_100',
  'KRT_01_50_L_99',
  'KRT_01_50_N_100',
  'KRT_01_50_N_99',
  'KRT_01_51_L_101',
  'KRT_01_51_L_102',
  'KRT_01_51_N_101',
  'KRT_01_51_N_102',
  'KRT_01_52_L_103',
  'KRT_01_52_L_104',
  'KRT_01_52_N_103',
  'KRT_01_52_N_104',
  'KRT_01_53_L_105',
  'KRT_01_53_L_106',
  'KRT_01_53_N_105',
  'KRT_01_53_N_106',
  'KRT_01_54_L_107',
  'KRT_01_54_L_108',
  'KRT_01_54_N_107',
  'KRT_01_54_N_108',
  'KRT_01_55_L_109',
  'KRT_01_55_L_110',
  'KRT_01_55_N_109',
  'KRT_01_55_N_110',
  'KRT_01_56_L_111',
  'KRT_01_56_L_112',
  'KRT_01_56_N_111',
  'KRT_01_56_N_112',
  'KRT_01_57_L_113',
  'KRT_01_57_L_114',
  'KRT_01_57_N_113',
  'KRT_01_57_N_114',
  'KRT_01_58_L_115',
  'KRT_01_58_L_116',
  'KRT_01_58_N_115',
  'KRT_01_58_N_116',
  'KRT_01_59_L_117',
  'KRT_01_59_L_118',
  'KRT_01_59_N_117',
  'KRT_01_59_N_118',
  'KRT_01_60_L_119',
  'KRT_01_60_L_120',
  'KRT_01_60_N_119',
  'KRT_01_60_N_120',
  'KRT_01_61_L_121',
  'KRT_01_61_L_122',
  'KRT_01_61_N_121',
  'KRT_01_61_N_122',
  'KRT_01_62_L_123',
  'KRT_01_62_L_124',
  'KRT_01_62_N_123',
  'KRT_01_62_N_124',
  'KRT_01_63_L_125',
  'KRT_01_63_L_126',
  'KRT_01_63_N_125',
  'KRT_01_63_N_126',
  'KRT_01_64_L_127',
  'KRT_01_64_L_128',
  'KRT_01_64_N_127',
  'KRT_01_64_N_128',
  'KRT_01_65_L_129',
  'KRT_01_65_L_130',
  'KRT_01_65_N_129',
  'KRT_01_65_N_130',
  'KRT_01_66_L_131',
  'KRT_01_66_L_132',
  'KRT_01_66_N_131',
  'KRT_01_66_N_132',
  'KRT_01_67_L_133',
  'KRT_01_67_L_134',
  'KRT_01_67_N_133',
  'KRT_01_67_N_134',
  'KRT_01_68_L_135',
  'KRT_01_68_L_136',
  'KRT_01_68_N_135',
  'KRT_01_68_N_136',
  'KRT_01_69_L_137',
  'KRT_01_69_L_138',
  'KRT_01_69_N_137',
  'KRT_01_69_N_138',
  'KRT_01_70_L_139',
  'KRT_01_70_L_140',
  'KRT_01_70_N_139',
  'KRT_01_70_N_140',
  'KRT_01_71_L_141',
  'KRT_01_71_L_142',
  'KRT_01_71_N_141',
  'KRT_01_71_N_142',
  'KRT_01_72_L_143',
  'KRT_01_72_L_144',
  'KRT_01_72_N_143',
  'KRT_01_72_N_144',
  'KRT_01_73_L_145',
  'KRT_01_73_L_146',
  'KRT_01_73_N_145',
  'KRT_01_73_N_146',
  'KRT_01_74_L_147',
  'KRT_01_74_L_148',
  'KRT_01_74_N_147',
  'KRT_01_74_N_148',
  'KRT_01_75_L_149',
  'KRT_01_75_L_150',
  'KRT_01_75_N_149',
  'KRT_01_75_N_150',
  'KRT_01_76_L_151',
  'KRT_01_76_L_152',
  'KRT_01_76_N_151',
  'KRT_01_76_N_152',
  'KRT_01_77_L_153',
  'KRT_01_77_L_154',
  'KRT_01_77_N_153',
  'KRT_01_77_N_154',
  'KRT_01_78_L_155',
  'KRT_01_78_L_156',
  'KRT_01_78_N_155',
  'KRT_01_78_N_156',
  'KRT_01_79_L_157',
  'KRT_01_79_L_158',
  'KRT_01_79_N_157',
  'KRT_01_79_N_158',
  'KRT_01_80_L_159',
  'KRT_01_80_L_160',
  'KRT_01_80_N_159',
  'KRT_01_80_N_160',
  'KRT_01_81_L_161',
  'KRT_01_81_L_162',
  'KRT_01_81_N_161',
  'KRT_01_81_N_162',
  'KRT_01_82_L_163',
  'KRT_01_82_L_164',
  'KRT_01_82_N_163',
  'KRT_01_82_N_164',
  'KRT_01_83_L_165',
  'KRT_01_83_L_166',
  'KRT_01_83_N_165',
  'KRT_01_83_N_166',
  'KRT_01_84_L_167',
  'KRT_01_84_L_168',
  'KRT_01_84_N_167',
  'KRT_01_84_N_168',
  'KRT_01_85_L_169',
  'KRT_01_85_L_170',
  'KRT_01_85_N_169',
  'KRT_01_85_N_170',
  'KRT_01_86_L_171',
  'KRT_01_86_L_172',
  'KRT_01_86_N_171',
  'KRT_01_86_N_172',
  'KRT_01_87_L_173',
  'KRT_01_87_L_174',
  'KRT_01_87_N_173',
  'KRT_01_87_N_174',
  'KRT_01_88_L_175',
  'KRT_01_88_L_176',
  'KRT_01_88_N_175',
  'KRT_01_88_N_176',
  'KRT_01_89_L_177',
  'KRT_01_89_L_178',
  'KRT_01_89_N_177',
  'KRT_01_89_N_178',
  'KRT_01_90_L_179',
  'KRT_01_90_L_180',
  'KRT_01_90_N_179',
  'KRT_01_90_N_180',
  'KRT_01_91_L_181',
  'KRT_01_91_L_182',
  'KRT_01_91_N_181',
  'KRT_01_91_N_182',
  'KRT_01_92_L_183',
  'KRT_01_92_L_184',
  'KRT_01_92_N_183',
  'KRT_01_92_N_184',
  'KRT_01_93_L_185',
  'KRT_01_93_L_186',
  'KRT_01_93_N_185',
  'KRT_01_93_N_186',
  'KRT_01_94_L_187',
  'KRT_01_94_L_188',
  'KRT_01_94_N_187',
  'KRT_01_94_N_188',
  'KRT_01_95_L_189',
  'KRT_01_95_L_190',
  'KRT_01_95_N_189',
  'KRT_01_95_N_190',
  'KRT_01_96_L_191',
  'KRT_01_96_L_192',
  'KRT_01_96_N_191',
  'KRT_01_96_N_192',
  'KRT_02_01_L_01',
  'KRT_02_01_L_02',
  'KRT_02_01_N_01',
  'KRT_02_01_N_02',
  'KRT_02_02_L_03',
  'KRT_02_02_L_04',
  'KRT_02_02_N_03',
  'KRT_02_02_N_04',
  'KRT_02_03_L_05',
  'KRT_02_03_L_06',
  'KRT_02_03_N_05',
  'KRT_02_03_N_06',
  'KRT_02_04_L_07',
  'KRT_02_04_L_08',
  'KRT_02_04_N_07',
  'KRT_02_04_N_08',
  'KRT_02_05_L_09',
  'KRT_02_05_L_10',
  'KRT_02_05_N_09',
  'KRT_02_05_N_10',
  'KRT_02_06_L_11',
  'KRT_02_06_L_12',
  'KRT_02_06_N_11',
  'KRT_02_06_N_12',
  'KRT_02_07_L_13',
  'KRT_02_07_L_14',
  'KRT_02_07_N_13',
  'KRT_02_07_N_14',
  'KRT_02_08_L_15',
  'KRT_02_08_L_16',
  'KRT_02_08_N_15',
  'KRT_02_08_N_16',
  'KRT_02_09_L_17',
  'KRT_02_09_L_18',
  'KRT_02_09_N_17',
  'KRT_02_09_N_18',
  'KRT_02_10_L_19',
  'KRT_02_10_L_20',
  'KRT_02_10_N_19',
  'KRT_02_10_N_20',
  'KRT_02_11_L_21',
  'KRT_02_11_L_22',
  'KRT_02_11_N_21',
  'KRT_02_11_N_22',
  'KRT_02_12_L_23',
  'KRT_02_12_L_24',
  'KRT_02_12_N_23',
  'KRT_02_12_N_24',
  'KRT_02_13_L_25',
  'KRT_02_13_L_26',
  'KRT_02_13_N_25',
  'KRT_02_13_N_26',
  'KRT_02_14_L_27',
  'KRT_02_14_L_28',
  'KRT_02_14_N_27',
  'KRT_02_14_N_28',
  'KRT_02_15_L_29',
  'KRT_02_15_L_30',
  'KRT_02_15_N_29',
  'KRT_02_15_N_30',
  'KRT_02_16_L_31',
  'KRT_02_16_L_32',
  'KRT_02_16_N_31',
  'KRT_02_16_N_32',
  'KRT_02_17_L_33',
  'KRT_02_17_L_34',
  'KRT_02_17_N_33',
  'KRT_02_17_N_34',
  'KRT_02_18_L_35',
  'KRT_02_18_L_36',
  'KRT_02_18_N_35',
  'KRT_02_18_N_36',
  'KRT_02_19_L_37',
  'KRT_02_19_L_38',
  'KRT_02_19_N_37',
  'KRT_02_19_N_38',
  'KRT_02_20_L_39',
  'KRT_02_20_L_40',
  'KRT_02_20_N_39',
  'KRT_02_20_N_40',
  'KRT_02_21_L_41',
  'KRT_02_21_L_42',
  'KRT_02_21_N_41',
  'KRT_02_21_N_42',
  'KRT_02_22_L_43',
  'KRT_02_22_L_44',
  'KRT_02_22_N_43',
  'KRT_02_22_N_44',
  'KRT_02_23_L_45',
  'KRT_02_23_L_46',
  'KRT_02_23_N_45',
  'KRT_02_23_N_46',
  'KRT_02_24_L_47',
  'KRT_02_24_L_48',
  'KRT_02_24_N_47',
  'KRT_02_24_N_48',
  'KRT_02_25_L_49',
  'KRT_02_25_L_50',
  'KRT_02_25_N_49',
  'KRT_02_25_N_50',
  'KRT_02_26_L_51',
  'KRT_02_26_L_52',
  'KRT_02_26_N_51',
  'KRT_02_26_N_52',
  'KRT_02_27_L_53',
  'KRT_02_27_L_54',
  'KRT_02_27_N_53',
  'KRT_02_27_N_54',
  'KRT_02_28_L_55',
  'KRT_02_28_L_56',
  'KRT_02_28_N_55',
  'KRT_02_28_N_56',
  'KRT_02_29_L_57',
  'KRT_02_29_L_58',
  'KRT_02_29_N_57',
  'KRT_02_29_N_58',
  'KRT_02_30_L_59',
  'KRT_02_30_L_60',
  'KRT_02_30_N_59',
  'KRT_02_30_N_60',
  'KRT_02_31_L_61',
  'KRT_02_31_L_62',
  'KRT_02_31_N_61',
  'KRT_02_31_N_62',
  'KRT_02_32_L_63',
  'KRT_02_32_L_64',
  'KRT_02_32_N_63',
  'KRT_02_32_N_64',
  'KRT_02_33_L_65',
  'KRT_02_33_L_66',
  'KRT_02_33_N_65',
  'KRT_02_33_N_66',
  'KRT_02_34_L_67',
  'KRT_02_34_L_68',
  'KRT_02_34_N_67',
  'KRT_02_34_N_68',
  'KRT_02_35_L_69',
  'KRT_02_35_L_70',
  'KRT_02_35_N_69',
  'KRT_02_35_N_70',
  'KRT_02_36_L_71',
  'KRT_02_36_L_72',
  'KRT_02_36_N_71',
  'KRT_02_36_N_72',
  'KRT_02_37_L_73',
  'KRT_02_37_L_74',
  'KRT_02_37_N_73',
  'KRT_02_37_N_74',
  'KRT_02_38_L_75',
  'KRT_02_38_L_76',
  'KRT_02_38_N_75',
  'KRT_02_38_N_76',
  'KRT_02_39_L_77',
  'KRT_02_39_L_78',
  'KRT_02_39_N_77',
  'KRT_02_39_N_78',
  'KRT_02_40_L_79',
  'KRT_02_40_L_80',
  'KRT_02_40_N_79',
  'KRT_02_40_N_80',
  'KRT_02_41_L_81',
  'KRT_02_41_L_82',
  'KRT_02_41_N_81',
  'KRT_02_41_N_82',
  'KRT_02_42_L_83',
  'KRT_02_42_L_84',
  'KRT_02_42_N_83',
  'KRT_02_42_N_84',
  'KRT_02_43_L_85',
  'KRT_02_43_L_86',
  'KRT_02_43_N_85',
  'KRT_02_43_N_86',
  'KRT_02_44_L_87',
  'KRT_02_44_L_88',
  'KRT_02_44_N_87',
  'KRT_02_44_N_88',
  'KRT_02_45_L_89',
  'KRT_02_45_L_90',
  'KRT_02_45_N_89',
  'KRT_02_45_N_90',
  'KRT_02_46_L_91',
  'KRT_02_46_L_92',
  'KRT_02_46_N_91',
  'KRT_02_46_N_92',
  'KRT_02_47_L_93',
  'KRT_02_47_L_94',
  'KRT_02_47_N_93',
  'KRT_02_47_N_94',
  'KRT_02_48_L_95',
  'KRT_02_48_L_96',
  'KRT_02_48_N_95',
  'KRT_02_48_N_96',
  'KRT_02_49_L_97',
  'KRT_02_49_L_98',
  'KRT_02_49_N_97',
  'KRT_02_49_N_98',
  'KRT_02_50_L_100',
  'KRT_02_50_L_99',
  'KRT_02_50_N_100',
  'KRT_02_50_N_99',
  'KRT_02_51_L_101',
  'KRT_02_51_L_102',
  'KRT_02_51_N_101',
  'KRT_02_51_N_102',
  'KRT_02_52_L_103',
  'KRT_02_52_L_104',
  'KRT_02_52_N_103',
  'KRT_02_52_N_104',
  'KRT_02_53_L_105',
  'KRT_02_53_L_106',
  'KRT_02_53_N_105',
  'KRT_02_53_N_106',
  'KRT_02_54_L_107',
  'KRT_02_54_L_108',
  'KRT_02_54_N_107',
  'KRT_02_54_N_108',
  'KRT_02_55_L_109',
  'KRT_02_55_L_110',
  'KRT_02_55_N_109',
  'KRT_02_55_N_110',
  'KRT_02_56_L_111',
  'KRT_02_56_L_112',
  'KRT_02_56_N_111',
  'KRT_02_56_N_112',
  'KRT_02_57_L_113',
  'KRT_02_57_L_114',
  'KRT_02_57_N_113',
  'KRT_02_57_N_114',
  'KRT_02_58_L_115',
  'KRT_02_58_L_116',
  'KRT_02_58_N_115',
  'KRT_02_58_N_116',
  'KRT_02_59_L_117',
  'KRT_02_59_L_118',
  'KRT_02_59_N_117',
  'KRT_02_59_N_118',
  'KRT_02_60_L_119',
  'KRT_02_60_L_120',
  'KRT_02_60_N_119',
  'KRT_02_60_N_120',
  'KRT_02_61_L_121',
  'KRT_02_61_L_122',
  'KRT_02_61_N_121',
  'KRT_02_61_N_122',
  'KRT_02_62_L_123',
  'KRT_02_62_L_124',
  'KRT_02_62_N_123',
  'KRT_02_62_N_124',
  'KRT_02_63_L_125',
  'KRT_02_63_L_126',
  'KRT_02_63_N_125',
  'KRT_02_63_N_126',
  'KRT_02_64_L_127',
  'KRT_02_64_L_128',
  'KRT_02_64_N_127',
  'KRT_02_64_N_128',
  'KRT_02_65_L_129',
  'KRT_02_65_L_130',
  'KRT_02_65_N_129',
  'KRT_02_65_N_130',
  'KRT_02_66_L_131',
  'KRT_02_66_L_132',
  'KRT_02_66_N_131',
  'KRT_02_66_N_132',
  'KRT_02_67_L_133',
  'KRT_02_67_L_134',
  'KRT_02_67_N_133',
  'KRT_02_67_N_134',
  'KRT_02_68_L_135',
  'KRT_02_68_L_136',
  'KRT_02_68_N_135',
  'KRT_02_68_N_136',
  'KRT_02_69_L_137',
  'KRT_02_69_L_138',
  'KRT_02_69_N_137',
  'KRT_02_69_N_138',
  'KRT_02_70_L_139',
  'KRT_02_70_L_140',
  'KRT_02_70_N_139',
  'KRT_02_70_N_140',
  'KRT_02_71_L_141',
  'KRT_02_71_L_142',
  'KRT_02_71_N_141',
  'KRT_02_71_N_142',
  'KRT_02_72_L_143',
  'KRT_02_72_L_144',
  'KRT_02_72_N_143',
  'KRT_02_72_N_144',
  'KRT_02_73_L_145',
  'KRT_02_73_L_146',
  'KRT_02_73_N_145',
  'KRT_02_73_N_146',
  'KRT_02_74_L_147',
  'KRT_02_74_L_148',
  'KRT_02_74_N_147',
  'KRT_02_74_N_148',
  'KRT_02_75_L_149',
  'KRT_02_75_L_150',
  'KRT_02_75_N_149',
  'KRT_02_75_N_150',
  'KRT_02_76_L_151',
  'KRT_02_76_L_152',
  'KRT_02_76_N_151',
  'KRT_02_76_N_152',
  'KRT_02_77_L_153',
  'KRT_02_77_L_154',
  'KRT_02_77_N_153',
  'KRT_02_77_N_154',
  'KRT_02_78_L_155',
  'KRT_02_78_L_156',
  'KRT_02_78_N_155',
  'KRT_02_78_N_156',
  'KRT_02_79_L_157',
  'KRT_02_79_L_158',
  'KRT_02_79_N_157',
  'KRT_02_79_N_158',
  'KRT_02_80_L_159',
  'KRT_02_80_L_160',
  'KRT_02_80_N_159',
  'KRT_02_80_N_160',
  'KRT_02_81_L_161',
  'KRT_02_81_L_162',
  'KRT_02_81_N_161',
  'KRT_02_81_N_162',
  'KRT_02_82_L_163',
  'KRT_02_82_L_164',
  'KRT_02_82_N_163',
  'KRT_02_82_N_164',
  'KRT_02_83_L_165',
  'KRT_02_83_L_166',
  'KRT_02_83_N_165',
  'KRT_02_83_N_166',
  'KRT_02_84_L_167',
  'KRT_02_84_L_168',
  'KRT_02_84_N_167',
  'KRT_02_84_N_168',
  'KRT_02_85_L_169',
  'KRT_02_85_L_170',
  'KRT_02_85_N_169',
  'KRT_02_85_N_170',
  'KRT_02_86_L_171',
  'KRT_02_86_L_172',
  'KRT_02_86_N_171',
  'KRT_02_86_N_172',
  'KRT_02_87_L_173',
  'KRT_02_87_L_174',
  'KRT_02_87_N_173',
  'KRT_02_87_N_174',
  'KRT_02_88_L_175',
  'KRT_02_88_L_176',
  'KRT_02_88_N_175',
  'KRT_02_88_N_176',
  'KRT_02_89_L_177',
  'KRT_02_89_L_178',
  'KRT_02_89_N_177',
  'KRT_02_89_N_178',
  'KRT_02_90_L_179',
  'KRT_02_90_L_180',
  'KRT_02_90_N_179',
  'KRT_02_90_N_180',
  'KRT_02_91_L_181',
  'KRT_02_91_L_182',
  'KRT_02_91_N_181',
  'KRT_02_91_N_182',
  'KRT_02_92_L_183',
  'KRT_02_92_L_184',
  'KRT_02_92_N_183',
  'KRT_02_92_N_184',
  'KRT_02_93_L_185',
  'KRT_02_93_L_186',
  'KRT_02_93_N_185',
  'KRT_02_93_N_186',
  'KRT_02_94_L_187',
  'KRT_02_94_L_188',
  'KRT_02_94_N_187',
  'KRT_02_94_N_188',
  'KRT_02_95_L_189',
  'KRT_02_95_L_190',
  'KRT_02_95_N_189',
  'KRT_02_95_N_190',
  'KRT_02_96_L_191',
  'KRT_02_96_L_192',
  'KRT_02_96_N_191',
  'KRT_02_96_N_192',
  'KRT_03_01_L_01',
  'KRT_03_01_L_02',
  'KRT_03_01_N_01',
  'KRT_03_01_N_02',
  'KRT_03_02_L_03',
  'KRT_03_02_L_04',
  'KRT_03_02_N_03',
  'KRT_03_02_N_04',
  'KRT_03_03_L_05',
  'KRT_03_03_L_06',
  'KRT_03_03_N_05',
  'KRT_03_03_N_06',
  'KRT_03_04_L_07',
  'KRT_03_04_L_08',
  'KRT_03_04_N_07',
  'KRT_03_04_N_08',
  'KRT_03_05_L_09',
  'KRT_03_05_L_10',
  'KRT_03_05_N_09',
  'KRT_03_05_N_10',
  'KRT_03_06_L_11',
  'KRT_03_06_L_12',
  'KRT_03_06_N_11',
  'KRT_03_06_N_12',
  'KRT_03_07_L_13',
  'KRT_03_07_L_14',
  'KRT_03_07_N_13',
  'KRT_03_07_N_14',
  'KRT_03_08_L_15',
  'KRT_03_08_L_16',
  'KRT_03_08_N_15',
  'KRT_03_08_N_16',
  'KRT_03_09_L_17',
  'KRT_03_09_L_18',
  'KRT_03_09_N_17',
  'KRT_03_09_N_18',
  'KRT_03_10_L_19',
  'KRT_03_10_L_20',
  'KRT_03_10_N_19',
  'KRT_03_10_N_20',
  'KRT_03_11_L_21',
  'KRT_03_11_L_22',
  'KRT_03_11_N_21',
  'KRT_03_11_N_22',
  'KRT_03_12_L_23',
  'KRT_03_12_L_24',
  'KRT_03_12_N_23',
  'KRT_03_12_N_24',
  'KRT_03_13_L_25',
  'KRT_03_13_L_26',
  'KRT_03_13_N_25',
  'KRT_03_13_N_26',
  'KRT_03_14_L_27',
  'KRT_03_14_L_28',
  'KRT_03_14_N_27',
  'KRT_03_14_N_28',
  'KRT_03_15_L_29',
  'KRT_03_15_L_30',
  'KRT_03_15_N_29',
  'KRT_03_15_N_30',
  'KRT_03_16_L_31',
  'KRT_03_16_L_32',
  'KRT_03_16_N_31',
  'KRT_03_16_N_32',
  'KRT_03_17_L_33',
  'KRT_03_17_L_34',
  'KRT_03_17_N_33',
  'KRT_03_17_N_34',
  'KRT_03_18_L_35',
  'KRT_03_18_L_36',
  'KRT_03_18_N_35',
  'KRT_03_18_N_36',
  'KRT_03_19_L_37',
  'KRT_03_19_L_38',
  'KRT_03_19_N_37',
  'KRT_03_19_N_38',
  'KRT_03_20_L_39',
  'KRT_03_20_L_40',
  'KRT_03_20_N_39',
  'KRT_03_20_N_40',
  'KRT_03_21_L_41',
  'KRT_03_21_L_42',
  'KRT_03_21_N_41',
  'KRT_03_21_N_42',
  'KRT_03_22_L_43',
  'KRT_03_22_L_44',
  'KRT_03_22_N_43',
  'KRT_03_22_N_44',
  'KRT_03_23_L_45',
  'KRT_03_23_L_46',
  'KRT_03_23_N_45',
  'KRT_03_23_N_46',
  'KRT_03_24_L_47',
  'KRT_03_24_L_48',
  'KRT_03_24_N_47',
  'KRT_03_24_N_48',
  'KRT_03_25_L_49',
  'KRT_03_25_L_50',
  'KRT_03_25_N_49',
  'KRT_03_25_N_50',
  'KRT_03_26_L_51',
  'KRT_03_26_L_52',
  'KRT_03_26_N_51',
  'KRT_03_26_N_52',
  'KRT_03_27_L_53',
  'KRT_03_27_L_54',
  'KRT_03_27_N_53',
  'KRT_03_27_N_54',
  'KRT_03_28_L_55',
  'KRT_03_28_L_56',
  'KRT_03_28_N_55',
  'KRT_03_28_N_56',
  'KRT_03_29_L_57',
  'KRT_03_29_L_58',
  'KRT_03_29_N_57',
  'KRT_03_29_N_58',
  'KRT_03_30_L_59',
  'KRT_03_30_L_60',
  'KRT_03_30_N_59',
  'KRT_03_30_N_60',
  'KRT_03_31_L_61',
  'KRT_03_31_L_62',
  'KRT_03_31_N_61',
  'KRT_03_31_N_62',
  'KRT_03_32_L_63',
  'KRT_03_32_L_64',
  'KRT_03_32_N_63',
  'KRT_03_32_N_64',
  'KRT_03_33_L_65',
  'KRT_03_33_L_66',
  'KRT_03_33_N_65',
  'KRT_03_33_N_66',
  'KRT_03_34_L_67',
  'KRT_03_34_L_68',
  'KRT_03_34_N_67',
  'KRT_03_34_N_68',
  'KRT_03_35_L_69',
  'KRT_03_35_L_70',
  'KRT_03_35_N_69',
  'KRT_03_35_N_70',
  'KRT_03_36_L_71',
  'KRT_03_36_L_72',
  'KRT_03_36_N_71',
  'KRT_03_36_N_72',
  'KRT_03_37_L_73',
  'KRT_03_37_L_74',
  'KRT_03_37_N_73',
  'KRT_03_37_N_74',
  'KRT_03_38_L_75',
  'KRT_03_38_L_76',
  'KRT_03_38_N_75',
  'KRT_03_38_N_76',
  'KRT_03_39_L_77',
  'KRT_03_39_L_78',
  'KRT_03_39_N_77',
  'KRT_03_39_N_78',
  'KRT_03_40_L_79',
  'KRT_03_40_L_80',
  'KRT_03_40_N_79',
  'KRT_03_40_N_80',
  'KRT_03_41_L_81',
  'KRT_03_41_L_82',
  'KRT_03_41_N_81',
  'KRT_03_41_N_82',
  'KRT_03_42_L_83',
  'KRT_03_42_L_84',
  'KRT_03_42_N_83',
  'KRT_03_42_N_84',
  'KRT_03_43_L_85',
  'KRT_03_43_L_86',
  'KRT_03_43_N_85',
  'KRT_03_43_N_86',
  'KRT_03_44_L_87',
  'KRT_03_44_L_88',
  'KRT_03_44_N_87',
  'KRT_03_44_N_88',
  'KRT_03_45_L_89',
  'KRT_03_45_L_90',
  'KRT_03_45_N_89',
  'KRT_03_45_N_90',
  'KRT_03_46_L_91',
  'KRT_03_46_L_92',
  'KRT_03_46_N_91',
  'KRT_03_46_N_92',
  'KRT_03_47_L_93',
  'KRT_03_47_L_94',
  'KRT_03_47_N_93',
  'KRT_03_47_N_94',
  'KRT_03_48_L_95',
  'KRT_03_48_L_96',
  'KRT_03_48_N_95',
  'KRT_03_48_N_96',
  'KRT_03_49_L_97',
  'KRT_03_49_L_98',
  'KRT_03_49_N_97',
  'KRT_03_49_N_98',
  'KRT_03_50_L_100',
  'KRT_03_50_L_99',
  'KRT_03_50_N_100',
  'KRT_03_50_N_99',
  'KRT_03_51_L_101',
  'KRT_03_51_L_102',
  'KRT_03_51_N_101',
  'KRT_03_51_N_102',
  'KRT_03_52_L_103',
  'KRT_03_52_L_104',
  'KRT_03_52_N_103',
  'KRT_03_52_N_104',
  'KRT_03_53_L_105',
  'KRT_03_53_L_106',
  'KRT_03_53_N_105',
  'KRT_03_53_N_106',
  'KRT_03_54_L_107',
  'KRT_03_54_L_108',
  'KRT_03_54_N_107',
  'KRT_03_54_N_108',
  'KRT_03_55_L_109',
  'KRT_03_55_L_110',
  'KRT_03_55_N_109',
  'KRT_03_55_N_110',
  'KRT_03_56_L_111',
  'KRT_03_56_L_112',
  'KRT_03_56_N_111',
  'KRT_03_56_N_112',
  'KRT_03_57_L_113',
  'KRT_03_57_L_114',
  'KRT_03_57_N_113',
  'KRT_03_57_N_114',
  'KRT_03_58_L_115',
  'KRT_03_58_L_116',
  'KRT_03_58_N_115',
  'KRT_03_58_N_116',
  'KRT_03_59_L_117',
  'KRT_03_59_L_118',
  'KRT_03_59_N_117',
  'KRT_03_59_N_118',
  'KRT_03_60_L_119',
  'KRT_03_60_L_120',
  'KRT_03_60_N_119',
  'KRT_03_60_N_120',
  'KRT_03_61_L_121',
  'KRT_03_61_L_122',
  'KRT_03_61_N_121',
  'KRT_03_61_N_122',
  'KRT_03_62_L_123',
  'KRT_03_62_L_124',
  'KRT_03_62_N_123',
  'KRT_03_62_N_124',
  'KRT_03_63_L_125',
  'KRT_03_63_L_126',
  'KRT_03_63_N_125',
  'KRT_03_63_N_126',
  'KRT_03_64_L_127',
  'KRT_03_64_L_128',
  'KRT_03_64_N_127',
  'KRT_03_64_N_128',
  'KRT_03_65_L_129',
  'KRT_03_65_L_130',
  'KRT_03_65_N_129',
  'KRT_03_65_N_130',
  'KRT_03_66_L_131',
  'KRT_03_66_L_132',
  'KRT_03_66_N_131',
  'KRT_03_66_N_132',
  'KRT_03_67_L_133',
  'KRT_03_67_L_134',
  'KRT_03_67_N_133',
  'KRT_03_67_N_134',
  'KRT_03_68_L_135',
  'KRT_03_68_L_136',
  'KRT_03_68_N_135',
  'KRT_03_68_N_136',
  'KRT_03_69_L_137',
  'KRT_03_69_L_138',
  'KRT_03_69_N_137',
  'KRT_03_69_N_138',
  'KRT_03_70_L_139',
  'KRT_03_70_L_140',
  'KRT_03_70_N_139',
  'KRT_03_70_N_140',
  'KRT_03_71_L_141',
  'KRT_03_71_L_142',
  'KRT_03_71_N_141',
  'KRT_03_71_N_142',
  'KRT_03_72_L_143',
  'KRT_03_72_L_144',
  'KRT_03_72_N_143',
  'KRT_03_72_N_144',
  'KRT_03_73_L_145',
  'KRT_03_73_L_146',
  'KRT_03_73_N_145',
  'KRT_03_73_N_146',
  'KRT_03_74_L_147',
  'KRT_03_74_L_148',
  'KRT_03_74_N_147',
  'KRT_03_74_N_148',
  'KRT_03_75_L_149',
  'KRT_03_75_L_150',
  'KRT_03_75_N_149',
  'KRT_03_75_N_150',
  'KRT_03_76_L_151',
  'KRT_03_76_L_152',
  'KRT_03_76_N_151',
  'KRT_03_76_N_152',
  'KRT_03_77_L_153',
  'KRT_03_77_L_154',
  'KRT_03_77_N_153',
  'KRT_03_77_N_154',
  'KRT_03_78_L_155',
  'KRT_03_78_L_156',
  'KRT_03_78_N_155',
  'KRT_03_78_N_156',
  'KRT_03_79_L_157',
  'KRT_03_79_L_158',
  'KRT_03_79_N_157',
  'KRT_03_79_N_158',
  'KRT_03_80_L_159',
  'KRT_03_80_L_160',
  'KRT_03_80_N_159',
  'KRT_03_80_N_160',
  'KRT_03_81_L_161',
  'KRT_03_81_L_162',
  'KRT_03_81_N_161',
  'KRT_03_81_N_162',
  'KRT_03_82_L_163',
  'KRT_03_82_L_164',
  'KRT_03_82_N_163',
  'KRT_03_82_N_164',
  'KRT_03_83_L_165',
  'KRT_03_83_L_166',
  'KRT_03_83_N_165',
  'KRT_03_83_N_166',
  'KRT_03_84_L_167',
  'KRT_03_84_L_168',
  'KRT_03_84_N_167',
  'KRT_03_84_N_168',
  'KRT_03_85_L_169',
  'KRT_03_85_L_170',
  'KRT_03_85_N_169',
  'KRT_03_85_N_170',
  'KRT_03_86_L_171',
  'KRT_03_86_L_172',
  'KRT_03_86_N_171',
  'KRT_03_86_N_172',
  'KRT_03_87_L_173',
  'KRT_03_87_L_174',
  'KRT_03_87_N_173',
  'KRT_03_87_N_174',
  'KRT_03_88_L_175',
  'KRT_03_88_L_176',
  'KRT_03_88_N_175',
  'KRT_03_88_N_176',
  'KRT_03_89_L_177',
  'KRT_03_89_L_178',
  'KRT_03_89_N_177',
  'KRT_03_89_N_178',
  'KRT_03_90_L_179',
  'KRT_03_90_L_180',
  'KRT_03_90_N_179',
  'KRT_03_90_N_180',
  'KRT_03_91_L_181',
  'KRT_03_91_L_182',
  'KRT_03_91_N_181',
  'KRT_03_91_N_182',
  'KRT_03_92_L_183',
  'KRT_03_92_L_184',
  'KRT_03_92_N_183',
  'KRT_03_92_N_184',
  'KRT_03_93_L_185',
  'KRT_03_93_L_186',
  'KRT_03_93_N_185',
  'KRT_03_93_N_186',
  'KRT_03_94_L_187',
  'KRT_03_94_L_188',
  'KRT_03_94_N_187',
  'KRT_03_94_N_188',
  'KRT_03_95_L_189',
  'KRT_03_95_L_190',
  'KRT_03_95_N_189',
  'KRT_03_95_N_190',
  'KRT_03_96_L_191',
  'KRT_03_96_L_192',
  'KRT_03_96_N_191',
  'KRT_03_96_N_192',
];

export const examsDataEx = [
  'KRT_E1_M1_L_00_01',
  'KRT_E1_M2_L_00_01',
  'KRT_E1_M3_L_00_01',
  'KRT_E2_1200_L_01_01',
  'KRT_E2_1200_L_02_01',
  'KRT_E2_1200_N_03_01',
  'KRT_E2_1200_N_04_01',
  'KRT_E2_1200_N_05_01',
  'KRT_E2_1200_N_06_01',
  'KRT_E2_1200_N_07_01',
  'KRT_E2_1200_N_08_01',
  'KRT_E2_1200_N_09_01',
  'KRT_E2_1250_L_01_01',
  'KRT_E2_1250_L_02_01',
  'KRT_E2_1250_N_03_01',
  'KRT_E2_1250_N_04_01',
  'KRT_E2_1250_N_05_01',
  'KRT_E2_1250_N_06_01',
  'KRT_E2_1250_N_07_01',
  'KRT_E2_1250_N_08_01',
  'KRT_E2_1250_N_09_01',
  'KRT_E2_1300_L_01_01',
  'KRT_E2_1300_L_02_01',
  'KRT_E2_1300_N_03_01',
  'KRT_E2_1300_N_04_01',
  'KRT_E2_1300_N_05_01',
  'KRT_E2_1300_N_06_01',
  'KRT_E2_1300_N_07_01',
  'KRT_E2_1300_N_08_01',
  'KRT_E2_1300_N_09_01',
  'KRT_E2_1350_L_01_01',
  'KRT_E2_1350_L_02_01',
  'KRT_E2_1350_N_03_01',
  'KRT_E2_1350_N_04_01',
  'KRT_E2_1350_N_05_01',
  'KRT_E2_1350_N_06_01',
  'KRT_E2_1350_N_07_01',
  'KRT_E2_1350_N_08_01',
  'KRT_E2_1350_N_09_01',
  'KRT_E2_1400_L_01_01',
  'KRT_E2_1400_L_02_01',
  'KRT_E2_1400_N_03_01',
  'KRT_E2_1400_N_04_01',
  'KRT_E2_1400_N_05_01',
  'KRT_E2_1400_N_06_01',
  'KRT_E2_1400_N_07_01',
  'KRT_E2_1400_N_08_01',
  'KRT_E2_1400_N_09_01',
  'KRT_E2_1450_L_01_01',
  'KRT_E2_1450_L_02_01',
  'KRT_E2_1450_N_03_01',
  'KRT_E2_1450_N_04_01',
  'KRT_E2_1450_N_05_01',
  'KRT_E2_1450_N_06_01',
  'KRT_E2_1450_N_07_01',
  'KRT_E2_1450_N_08_01',
  'KRT_E2_1450_N_09_01',
  'KRT_E2_1500_L_01_01',
  'KRT_E2_1500_L_02_01',
  'KRT_E2_1500_N_03_01',
  'KRT_E2_1500_N_04_01',
  'KRT_E2_1500_N_05_01',
  'KRT_E2_1500_N_06_01',
  'KRT_E2_1500_N_07_01',
  'KRT_E2_1500_N_08_01',
  'KRT_E2_1500_N_09_01',
  'KRT_E2_1550_L_01_01',
  'KRT_E2_1550_L_02_01',
  'KRT_E2_1550_N_03_01',
  'KRT_E2_1550_N_04_01',
  'KRT_E2_1550_N_05_01',
  'KRT_E2_1550_N_06_01',
  'KRT_E2_1550_N_07_01',
  'KRT_E2_1550_N_08_01',
  'KRT_E2_1550_N_09_01',
  'KRT_E2_1600_L_01_01',
  'KRT_E2_1600_L_02_01',
  'KRT_E2_1600_N_03_01',
  'KRT_E2_1600_N_04_01',
  'KRT_E2_1600_N_05_01',
  'KRT_E2_1600_N_06_01',
  'KRT_E2_1600_N_07_01',
  'KRT_E2_1600_N_08_01',
  'KRT_E2_1600_N_09_01',
];
export const examsDataSat = ['KRT_01_T1', 'KRT_01_T2', 'KRT_02_T1', 'KRT_02_T2', 'KRT_03_T1', 'KRT_03_T2'];

